@if (link) { } @else {
<div class="row">
  <div class="col">
    <span>Last refreshed on 7:45 PM</span>
    @if (!link) {
    <a [title]="title || label" [attr.aria-label]="title || label" href="javascript:;">
      @if (icon) {
      <fa-icon [icon]="icon"></fa-icon>
      }&nbsp; @if (label) {
      <span>{{ label }}</span>
      }
    </a>
    }
  </div>
</div>
} @if (!children?.length) {
<ng-content></ng-content>
}
